<script lang="ts" setup>
	import {useFilters} from '@/store/filter.store';
	import type {Option} from '@/types/search/filter.option';

	const emit = defineEmits(['filters-updated']);

	const props = defineProps<{
		filterName: string;
		option: Option;
	}>();

	const uncheckOption = (() => {
		useFilters().updateSelectedFilters(props.filterName, props.option.value);
		emit('filters-updated');
	});

</script>

<template>
	<div :id="'filter-part__selected-filter_' + filterName + '_' + option.value.replace(' ', '-')"
	     class="filter-part__selected-filter">

	    <span class="uncheck-selected-filter" @click="uncheckOption">
	        <svg class="icon-modal-close" height="10" width="10">
	            <use xlink:href="/assets/images/build/svg-sprite.min.svg#modal-close"></use>
	        </svg>
	    </span>
		<span v-if="option.iconStyle" :style="option.iconStyle" class="icon-color"></span>
		{{ option.label }}
	</div>
</template>
